(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("FormoAnalytics", [], factory);
	else if(typeof exports === 'object')
		exports["FormoAnalytics"] = factory();
	else
		root["FormoAnalytics"] = factory();
})(self, () => {
return 